import { createContext, useContext } from 'react';
import { useColorModeAttribute } from './useColorModeAttribute.js';
import { jsx } from '@emotion/react';
import '../../../hooks/useIsomorphicLayoutEffect.js';

const ColorModeContext = /*#__PURE__*/createContext("EXPERIMENTAL_light");
const useColorModeEXPERIMENTAL = () => {
  return useContext(ColorModeContext);
};
const ColorModeProvider = _ref => {
  let {
    themeProviderRef,
    children
  } = _ref;
  const attr = useColorModeAttribute(themeProviderRef);
  return jsx(ColorModeContext.Provider, {
    value: attr === "dark" ? "EXPERIMENTAL_dark" : "EXPERIMENTAL_light"
  }, children);
};

export { ColorModeProvider, useColorModeEXPERIMENTAL };
